<template>
    <div :class="bootstrapClass[lowerCaseTenantDomainTheme]">
        <slot></slot>
    </div>
</template>

<script>
import {tenantDomainTheme} from "../../../../../mixins/tenantDomainTheme";

export default {
    name: 'ThemedBootstrapCardBody',

    mixins: [
        tenantDomainTheme,
    ],

    data() {
        return {
            bootstrapClass: {
                artificialreason: 'panel-body no-padding',
                assan: 'card-body',
                eventrac: 'box-body',
            },
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCardBody.vue